<template>
  <div class="seckill-list main-1200-width padding-bottom-40">
    <div class="topbar">
      <el-button size="mini" @click="$router.back()">返回</el-button>
      <div class="title">{{ activityTitle }}</div>
      <div class="right">{{ remainText(activity) }}</div>
    </div>

    <div class="empty" v-if="!goods.length">暂无秒杀商品</div>

    <div class="grid" v-else>
      <div class="card" v-for="g in goods" :key="g.id" @click="goGoods(g.id)">
        <div class="cover">
          <img class="img" :src="$url.cdn(g.image)" :alt="g.title" />
        </div>
        <div class="name">{{ g.title }}</div>
        <div class="price-wrap" v-if="is_login">
          <div class="price-row">
            <span class="tag-seckill">秒杀价</span>
            <span class="price-sale">￥{{ formatSeckillGoodsPrice(g) }}</span>
          </div>
          <div v-if="seckillRefText(g)" class="price-ref">
            <span class="ref-label">日常价</span>
            <span class="ref-num">￥{{ seckillRefText(g) }}</span>
          </div>
        </div>
        <div class="price" v-else>价格：****</div>
        <div class="actions">
          <el-button type="danger" size="mini" class="btn">去秒杀</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import activityApi from '@/api/activity.js'
import goodsApi from '@/api/goods.js'
import {
  formatSeckillActivityPriceOnlyDisplay,
  formatSeckillCatalogFloorLineDisplay,
  getSeckillRefPriceText,
} from '@/units/activityGoodsPrice.js'
import {
  enrichGoodsListWithActivityDetail,
  normalizeActivityListRows,
} from '@/units/enrichSeckillGoodsFromDetail.js'

export default {
  data() {
    return {
      nowTs: Math.floor(Date.now() / 1000),
      timerId: null,
      activity: null,
      goods: [],
    }
  },
  computed: {
    ...mapGetters(['is_login']),
    activityId() {
      return Number((this.$route.query && this.$route.query.activity_id) || 0)
    },
    activityTitle() {
      return (this.activity && this.activity.title) ? this.activity.title : '秒杀活动'
    }
  },
  created() {
    this.timerId = setInterval(() => {
      this.nowTs = Math.floor(Date.now() / 1000)
    }, 1000)
    this.load()
  },
  beforeDestroy() {
    if (this.timerId) clearInterval(this.timerId)
  },
  watch: {
    '$route.query.activity_id'() {
      this.load()
    }
  },
  methods: {
    formatPrice(e) {
      return e && e.length === 1 ? e[0] : (e || []).join('~')
    },
    formatSeckillGoodsPrice(goods) {
      const act = formatSeckillActivityPriceOnlyDisplay(goods)
      return act || '—'
    },
    seckillRefText(goods) {
      return getSeckillRefPriceText(goods) || formatSeckillCatalogFloorLineDisplay(goods)
    },
    remainText(activity) {
      if (!activity) return ''
      const end = Number(activity.end_time || 0)
      const now = Number(this.nowTs || 0)
      const remain = end - now
      if (!end || !Number.isFinite(remain) || remain <= 0) return '活动已结束'
      const h = Math.floor(remain / 3600)
      const m = Math.floor((remain % 3600) / 60)
      const s = Math.floor(remain % 60)
      const pad = (n) => (n < 10 ? `0${n}` : `${n}`)
      return `距结束 ${pad(h)}:${pad(m)}:${pad(s)}`
    },
    async load() {
      const id = this.activityId
      if (!id) {
        this.activity = null
        this.goods = []
        return
      }
      try {
        const { data: actData } = await activityApi.activity(id)
        this.activity = actData || null
      } catch (e) {
        this.activity = null
      }

      try {
        const { data: goodsData } = await goodsApi.activityList({
          activity_id: id,
          page: 1,
          list_rows: 50,
        })
        const pageData = goodsData || {}
        const rows = normalizeActivityListRows(pageData.data || [])
        this.goods = rows
        enrichGoodsListWithActivityDetail(rows, id, 4).then((enriched) => {
          if (this.activityId === id) this.goods = enriched
        })
      } catch (e) {
        this.goods = []
      }
    },
    goGoods(goodsId) {
      this.$router.push({
        name: 'GoodsDetail',
        query: { id: goodsId, activity_id: this.activityId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.seckill-list {
  padding-top: 20px;
}
.topbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0 16px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
}
.right {
  margin-left: auto;
  font-size: 12px;
  color: #666;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
}
.empty {
  padding: 60px 0;
  text-align: center;
  color: #999;
}
.grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
}
.card {
  cursor: pointer;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.cover {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background: #fafafa;
}
.img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.name {
  padding: 10px 10px 0;
  font-size: 13px;
  color: #222;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
}
.price-wrap {
  padding: 6px 10px 0;
}
.price-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
}
.tag-seckill {
  padding: 0 5px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #ff4d4f, #ca141d);
  border-radius: 3px;
  line-height: 1.4;
}
.price-sale {
  color: #f5222d;
  font-weight: 800;
  font-size: 16px;
}
.price-ref {
  margin-top: 4px;
  font-size: 12px;
  color: #8c8c8c;
}
.ref-label {
  margin-right: 4px;
}
.ref-num {
  color: #bfbfbf;
  text-decoration: line-through;
  text-decoration-color: #bfbfbf;
  -webkit-text-decoration-line: line-through;
}
.price {
  padding: 6px 10px 0;
  color: #f5222d;
  font-weight: 700;
}
.actions {
  padding: 10px;
}
.btn {
  width: 100%;
}

@media (max-width: 1200px) {
  .grid { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 992px) {
  .grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
  .grid { grid-template-columns: repeat(2, 1fr); }
}
</style>

